export const API_URL = process.env.VUE_APP_SYNCIO_CORE_API_DOMAIN;
export const VUE_APP_ID = process.env.VUE_APP_ID;
export const VUE_APP_REMOTE_ACCESS_URL = process.env.VUE_APP_REMOTE_ACCESS_URL;
export const VUE_APP_V1_BASE_URL = process.env.VUE_APP_V1_BASE_URL;
export const VUE_APP_SHOPIFY_LOGIN = process.env.VUE_APP_SHOPIFY_LOGIN;
export default {API_URL, VUE_APP_ID, VUE_APP_REMOTE_ACCESS_URL, VUE_APP_V1_BASE_URL, VUE_APP_SHOPIFY_LOGIN};
